var __jsx = React.createElement;
import React from "react";
import Modal from "../common/Modal";
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import GatewayIndicator from ".";
function GatewayModal() {
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isVisible: s.isGatewayModalOpen
      };
    }),
    isVisible = _useStoreState.isVisible;
  var onCloseModal = function onCloseModal() {
    Store.update(function (s) {
      s.isGatewayModalOpen = false;
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    title: "Gateway Status",
    onClose: onCloseModal,
    show: isVisible,
    bgOpacity: true,
    className: "flex flex-col w-full sm:w-7/12 h-[88%] !bg-gray-100 dark:!bg-gray-800 lg:w-6/12 xl:w-4/12 sm:!h-auto sm:!max-h-[75%] overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement(GatewayIndicator, {
    isVisible: isVisible
  })));
}
export default GatewayModal;